import { Box, Typography } from '@mui/material'
import { Field } from 'formik'
import React from 'react'
import { BlueSwitch } from './Switch.styled'

type SwitchProps = {
  name: string
  value: boolean
  setFieldValue: (field: string, value: boolean) => void
  ariaLabel: string
  label: string
}

export const Switch = ({
  name,
  value,
  setFieldValue,
  ariaLabel,
  label,
}: SwitchProps) => {
  return (
    <Box
      display='flex'
      justifyContent='space-between'
      alignItems='center'
      mb={3}>
      <Typography variant='body2'>{label}</Typography>
      <Field
        name={name}
        component={BlueSwitch}
        value={value}
        checked={value}
        onChange={() => {
          setFieldValue('active', !value)
        }}
        aria-label={ariaLabel}
      />
    </Box>
  )
}
